"use strict";
var paginate_pipe_1 = require('./paginate-pipe');
exports.PaginatePipe = paginate_pipe_1.PaginatePipe;
var pagination_service_1 = require('./pagination-service');
exports.PaginationService = pagination_service_1.PaginationService;
var pagination_controls_cmp_1 = require('./pagination-controls-cmp');
exports.PaginationControlsCmp = pagination_controls_cmp_1.PaginationControlsCmp;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-pagination/dist/ng2-pagination.js
 ** module id = 868
 ** module chunks = 0
 **/